import {EMPTY_STRING, LOCAL_STORAGE} from "./CommonConstants";

export class LocalStorageApi {

    static getAccessToken = (): string => {
        const wartosc = localStorage.getItem(LOCAL_STORAGE.ACCESS_TOKEN);
        return wartosc ? wartosc : EMPTY_STRING
    };

    static isAccessTokenExists = (): boolean => {
        const accessToken: string = LocalStorageApi.getAccessToken();
        return accessToken !== EMPTY_STRING;
    };

    static setAccessToken = (accessToken: string) => {
        localStorage.setItem(LOCAL_STORAGE.ACCESS_TOKEN, accessToken);
    };

    static removeAccessToken = () => {
        localStorage.removeItem(LOCAL_STORAGE.ACCESS_TOKEN);
    };

    static getDispatcherUrl = (): string => {
        const wartosc = localStorage.getItem(LOCAL_STORAGE.DISPATCHER_URL);
        return wartosc ? wartosc : EMPTY_STRING
    };

    static isDispatcherUrlExists = (): boolean => {
        const accessToken: string = LocalStorageApi.getDispatcherUrl();
        return accessToken !== EMPTY_STRING;
    };

    static setDispatcherUrl = (accessToken: string) => {
        localStorage.setItem(LOCAL_STORAGE.DISPATCHER_URL, accessToken);
    };

    static removeDispatcherUrl = () => {
        localStorage.removeItem(LOCAL_STORAGE.DISPATCHER_URL);
    };

}